import React, { useEffect, useMemo, useRef, useState } from "react";
import cn from "classnames";
import Modal from "components/Common/Modal/Minimum";
import Button from "components/Common/Button/Text";
import styles from "./style.scss";
import TextField from "components/Common/TextField";

interface Props {
  isOpen: boolean;
  defaultTitle: string;
  onClose: () => void;
  onChatTitleEdit: (newTitle: string) => void;
}

const EditModal: React.FC<Props> = ({
  isOpen,
  defaultTitle,
  onClose,
  onChatTitleEdit
}) => {
  const [name, setName] = useState(defaultTitle);
  const inputRef = useRef<HTMLInputElement | null>(null);

  // モーダルが開いたときにテキストフィールドにフォーカスする
  useEffect(() => {
    if (!isOpen) return;

    const animationFrameId = requestAnimationFrame(() => {
      inputRef.current?.focus();
    });

    return () => cancelAnimationFrame(animationFrameId);
  }, [isOpen]);

  const validate = useMemo(() => {
    if (name.length > 500) {
      return "500文字以内で入力してください。";
    }

    return null;
  }, [name]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} header="チャットの名前を変更">
      <div className={styles.content}>
        <div
          className={cn(styles.textFieldWrapper, {
            [styles.error]: !!validate
          })}
        >
          <TextField
            value={name}
            onChange={value => setName(value)}
            error={validate || undefined}
            inputRef={inputRef}
          />
        </div>
        <div className={styles.buttonWrapper}>
          <Button color="navy" onClick={onClose}>
            キャンセル
          </Button>
          <Button
            color="orange"
            disabled={!!validate || name.trim().length === 0}
            onClick={() => {
              onChatTitleEdit(name);
              onClose();
            }}
          >
            変更
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default EditModal;
